import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import OrganizationServices from "services/OrganizationServices";
import EmployeesServices from "services/EmployeesServices";
import { MainCard, CardTitle, Progress } from 'components';
import CustomTabs from "./OrgComponets/Tab";
import OrganizationTab from "./OrgAdminTabs/OrgOrganizationTab";
import OrgBranchesTab from "./OrgAdminTabs/OrgBranchesTab";
import OrgDepartment from "./OrgAdminTabs/OrgDepartment";
import OrgOfficers from "./OrgAdminTabs/OrgOfficers";
import localStorageService from "services/localStorageService";

const TABS = [
	{ label: 'Organization', value: 'organization' },
	{ label: 'Branches', value: 'branches' },
	{ label: 'Departments', value: 'departments' },
	{ label: 'Officers', value: 'officers' },
];

function OrganizationManagement() {
	const [tab, setTab] = useState(TABS[0].value);
	const location = useLocation();
	let orgId = location.state?.org?.id || location.state?.id;
    console.log('orgId from location:', orgId);

  //const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        setError(null);
 
        const storedUser = localStorageService.getItem("user");
        if (!storedUser) {
          if (!cancelled) 
          return;
        }

        if (cancelled) return;
        

        const employeeRes = await EmployeesServices.getById(
          storedUser.userId ?? storedUser.id
        );
        if (cancelled) return;

        const orgId =
          employeeRes?.data?.view?.organization_id ??
          employeeRes?.data?.organization_id ??
          employeeRes?.organization_id;

        if (!orgId) {
          throw new Error("Organization ID not found for the current user.");
        }

        const orgRes = await OrganizationServices.getById(orgId);
        if (cancelled) return;

        console.log('Fetched organization data:', orgRes);
        if (!cancelled) {
        const adminDetails = await EmployeesServices.get(
        { organization_id: orgId, type: 'Organization Admin', status: 'Active' }
        );
        console.log('Admin Details:', adminDetails);
        setContactInfo(adminDetails?.data?.view?.data[0] || {name: 'NA',email:'NA',phone:'NA', address:'NA'});
        setOrganization(orgRes.data?.organization);

        } 
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error(String(err)));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (error) return <div style={{ color: "crimson" }}>Error: {error.message}</div>;

	return (
		<MainCard>
			<CustomTabs tabs={TABS} value={tab} onChange={(_, v) => setTab(v)} />
			{loading ? (
                      <Progress />  
                  ) : (
				<>
					{tab === 'organization' && (
						<>
							<CardTitle title="Organization" sx={{ mt: 2, mb: 2 }} />
							<OrganizationTab org={organization} contactInfo={contactInfo} />
						</>
					)}
					{tab === 'branches' && (
						<OrgBranchesTab org={organization} />
					)}
					{tab === 'departments' && (
						<OrgDepartment org={organization} />
					)}
					{tab === 'officers' && (
						<OrgOfficers org={organization} />
					)}
		
				</>
			)}
		</MainCard>
	);
}

export default OrganizationManagement;





